import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useLanguage from 'hooks/useLanguage';
import { Mixpanel } from 'mixpanel';
import useFocusedModule from 'hooks/useFocusedModule';
import useUser from 'api/hooks/useUser';

import CroptimizerContent from './screen/CroptimizerContent';
import { NextHandlerProvider } from './providers/NextHandlerContext';
import { CroptimizerProvider } from './providers/CroptimizerContext';

const Croptimizer = () => {
  const { i18n } = useTranslation();

  const { greenLang } = useLanguage();
  const { data: user } = useUser();

  useFocusedModule('Croptimizer Module Duration');

  useEffect(() => {
    if (user) {
      Mixpanel.track('Croptimizer Opened', {
        role: user?.role?.name,
        organization: user?.organization,
      });
    }
  }, [user]);

  useEffect(() => {
    if (greenLang.length > 0) {
      i18n.changeLanguage(greenLang);
    }
  }, [greenLang]);

  return (
    <NextHandlerProvider>
      <CroptimizerProvider>
        <CroptimizerContent />
      </CroptimizerProvider>
    </NextHandlerProvider>
  );
};

export default Croptimizer;
